import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {centerIslandThumbnail} from "../assets";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PLACEMENTS} from "../constants";

import Cabinet from "../subparts/centerIsland/cabinet";
import Faucet from "../subparts/centerIsland/faucet";
import Sink from "../subparts/centerIsland/sink";
import Edge from "../subparts/centerIsland/edge";
import Countertop from "../subparts/centerIsland/countertop";
import IslandHood from "../subparts/centerIsland/islandHood";
import Stovetop from "../subparts/centerIsland/stovetop";
import Pendants from "../subparts/centerIsland/pendants";
import RightIsland from "../subparts/centerIsland/rightIsland";
import {setActiveFeaturesBeforeAllWalls} from "../../../look/lookNavigation/lookNavigationFunctions";
import {CABINET_GROUP, COUNTERTOP_GROUP} from "../../../kvComponent/core/constants";

// () = ()

export default class CenterIsland extends Part {
  static id = 'CenterIsland';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'CenterIsland';
    this.partThumbnail = centerIslandThumbnail;
    this.translateId = "visualizer.kitchen.center_island";

    // related items
    this.cabinet = null;
    this.countertop = null;
    this.faucet = null;
    this.sink = null;
    this.edge = null;
    this.islandHood = null;
    this.relatedGroupNames = ["Center Island", "Center Island Countertop", "Faucet", "Sink", "Edge Profile",
      "Island Hood", "Stovetop", "Pendants", "Right Island"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      shouldLoadInDifferentGroups = false,
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Center Island":
      case "Cabinets Center Island":
      case "Center Island Cabinet":
        relatedItemName = "cabinet";
        RelatedItemClass = Cabinet;
        break;
      case "Center Island Countertop":
      case "Countertop Center Island":
        relatedItemName = "countertop";
        RelatedItemClass = Countertop;
        break;
      case "Faucet":
        if (loadFeature && ((dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Island)) || (!dbFeature.metaData["Placement"] && !dbFeature.s3Bindings))) {
          if (!dbFeature.metaData["Placement"]) {
            shouldLoadInDifferentGroups = true;
          }
          relatedItemName = "faucet";
          RelatedItemClass = Faucet;
        }
        break;
      case "Sink":
        if (loadFeature && ((dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Island)) || (!dbFeature.metaData["Placement"] && !dbFeature.s3Bindings))) {
          if (!dbFeature.metaData["Placement"]) {
            shouldLoadInDifferentGroups = true;
          }
          relatedItemName = "sink";
          RelatedItemClass = Sink;
        }
        break;
      case "Edge Profile":
      case "Edge":
        shouldLoadInDifferentGroups = true;
        relatedItemName = "edge";
        RelatedItemClass = Edge;
        break;
      case "Island hood":
      case "Island Hood":
        relatedItemName = "islandHood";
        RelatedItemClass = IslandHood;
        break;
      case "Island Stove":
        relatedItemName = "stovetop";
        RelatedItemClass = Stovetop;
        break;
      case "Pendants":
        relatedItemName = "pendants";
        RelatedItemClass = Pendants;
        break;
      case "Right Island":
        relatedItemName = "rightIsland";
        RelatedItemClass = RightIsland;
        break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature, shouldLoadInDifferentGroups)
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts(withHidden = true) {
    return this.relatedItems
      .filter(item => {
        if (item.partId === "center_island_handle") {
          item.visible = item.features.filter(f => f.matchesMetaForArrayOfConditions(item.getArrayOfConditions())).length;
        }
        return this.filterRelatedItem(item, withHidden)
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  handleSubPartClick() {

  }

  getCabinetType() {
    return this.cabinet && this.cabinet.activeFeature
      ? this.cabinet.activeFeature.dbFeature.metaData["Cabinet"]
      : ""
  }

  getChairType() {
    return this.chairs && this.chairs.activeFeature
      ? this.chairs.activeFeature.dbFeature.metaData["Chair"]
      : ""
  }

  setSpecificRules() {
    if (this.edge) {
      this.edge.setEdgeNotInVisualizer()
    }
  }

  setPrevioslySelected(featureGroup) {
    setActiveFeaturesBeforeAllWalls(featureGroup.partId === "center_island_cabinet" ? CABINET_GROUP : COUNTERTOP_GROUP);
  }

}
